export enum FormType {
  select,
  input,
  editor,
  dateRange,
  datePicker,
  custom,
  radio,
  checkbox,
  textArea,
  line,
  question,
  inputNumber,
}
